var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEmailModal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0H4.16667C1.66667 0 0 1.25 0 4.16667V10C0 12.9167 1.66667 14.1667 4.16667 14.1667H12.5C15 14.1667 16.6667 12.9167 16.6667 10V4.16667C16.6667 1.25 15 0 12.5 0ZM12.8917 5.075L10.2833 7.15833C9.73333 7.6 9.03333 7.81667 8.33333 7.81667C7.63333 7.81667 6.925 7.6 6.38333 7.15833L3.775 5.075C3.50833 4.85833 3.46667 4.45833 3.675 4.19167C3.89167 3.925 4.28333 3.875 4.55 4.09167L7.15833 6.175C7.79167 6.68333 8.86667 6.68333 9.5 6.175L12.1083 4.09167C12.375 3.875 12.775 3.91667 12.9833 4.19167C13.2 4.45833 13.1583 4.85833 12.8917 5.075Z",
    fill: "#009B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEmailModal);
export default __webpack_public_path__ + "static/media/ic-email-modal.215cda51c1ed2e956486a94a5529ffe1.svg";
export { ForwardRef as ReactComponent };